import { useState, useEffect } from "react";
import "./MonthPickerModal.css";

const MONTHS = [
    "Gen", "Feb", "Mar", "Apr",
    "Mag", "Giu", "Lug", "Ago",
    "Set", "Ott", "Nov", "Dic"
];

const MonthPickerModal = ({ value, onChange, min, max, label }) => {
    const [isTablet, setIsTablet] = useState(() => window.matchMedia("(max-width: 1024px)").matches);
    const [showModal, setShowModal] = useState(false);

    // Parse current value (format "YYYY-MM")
    const currentYear = value ? parseInt(value.split("-")[0]) : new Date().getFullYear();
    const currentMonth = value ? parseInt(value.split("-")[1]) : new Date().getMonth() + 1;

    const [selectedYear, setSelectedYear] = useState(currentYear);

    useEffect(() => {
        const mq = window.matchMedia("(max-width: 1024px)");
        const handler = (e) => setIsTablet(e.matches);
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);

    // Sync selectedYear when value changes
    useEffect(() => {
        if (value) setSelectedYear(parseInt(value.split("-")[0]));
    }, [value]);

    const isMonthDisabled = (monthIndex) => {
        const monthStr = `${selectedYear}-${String(monthIndex + 1).padStart(2, "0")}`;
        if (min && monthStr < min) return true;
        if (max && monthStr > max) return true;
        return false;
    };

    const handleMonthSelect = (monthIndex) => {
        if (isMonthDisabled(monthIndex)) return;
        const newValue = `${selectedYear}-${String(monthIndex + 1).padStart(2, "0")}`;
        onChange({ target: { value: newValue } });
        setShowModal(false);
    };

    const handleInputClick = (e) => {
        if (isTablet) {
            e.preventDefault();
            setShowModal(true);
        }
    };

    const formatDisplay = () => {
        if (!value) return "";
        const [y, m] = value.split("-");
        return `${MONTHS[parseInt(m) - 1]} ${y}`;
    };

    // Parse min/max years for navigation limits
    const minYear = min ? parseInt(min.split("-")[0]) : 2000;
    const maxYear = max ? parseInt(max.split("-")[0]) : 2100;

    return (
        <>
            {isTablet ? (
                <div className="month-picker-display" onClick={handleInputClick}>
                    <span>{formatDisplay() || "Seleziona mese"}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                </div>
            ) : (
                <input
                    type="month"
                    value={value || ""}
                    onChange={onChange}
                    min={min || undefined}
                    max={max || undefined}
                />
            )}

            {showModal && isTablet && (
                <div className="month-picker-overlay" onClick={() => setShowModal(false)}>
                    <div className="month-picker-modal" onClick={e => e.stopPropagation()}>
                        <h3>{label || "Seleziona mese"}</h3>

                        <div className="month-picker-year-nav">
                            <button
                                type="button"
                                onClick={() => setSelectedYear(y => Math.max(y - 1, minYear))}
                                disabled={selectedYear <= minYear}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="15 18 9 12 15 6" />
                                </svg>
                            </button>
                            <span className="month-picker-year">{selectedYear}</span>
                            <button
                                type="button"
                                onClick={() => setSelectedYear(y => Math.min(y + 1, maxYear))}
                                disabled={selectedYear >= maxYear}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 6 15 12 9 18" />
                                </svg>
                            </button>
                        </div>

                        <div className="month-picker-grid">
                            {MONTHS.map((month, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className={`month-picker-item${
                                        selectedYear === currentYear && index + 1 === currentMonth ? " active" : ""
                                    }${isMonthDisabled(index) ? " disabled" : ""}`}
                                    onClick={() => handleMonthSelect(index)}
                                    disabled={isMonthDisabled(index)}
                                >
                                    {month}
                                </button>
                            ))}
                        </div>

                        <button
                            type="button"
                            className="month-picker-cancel"
                            onClick={() => setShowModal(false)}
                        >
                            Annulla
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default MonthPickerModal;
